<div style="background-color: #3785bc; color: rgb(255, 255, 255); padding: 15px; text-align: center">
    <p style="font-size: 18px">{{ lang.GetValue('PrintMenu.FileExp') }}</p>
    <p>{{ lang.GetValue('PrintMenu.PleaseWait') }}</p>
    <img src="assets/img/loading2.gif" />
</div>
